import avatar2 from '../../img/avatar2.png';
import github from '../../img/git2.svg';
import tg from '../../img/tg2.svg';
import vk from '../../img/vk2.svg';
import Link from '../../components/link/link';
import InfoAdd from '../../components/infoAdd/infoAdd';
import Btn from '../../components/btn/btn';
import './info.scss';

function Info() {
  return (
    <>
      <div className='info'>
        <img className='info__avatar' src={avatar2} alt='avatar'></img>
        <div className='info__main'>
          <h1 className='info__main__name'>Pavel Khristenko</h1>
          <h2 className='info__main__spec'>Front-end web development</h2>
          <div className='info__main__links'>
            <Link src={github} href='https://github.com/8Cofiman' alt='github' />
            <Link src={tg} href='https://t.me/cofiman8' alt='telegram' />
            <Link src={vk} href='https://vk.com/cofiman' alt='VK' />
          </div>
        </div>
      </div>
      <div className='infoMore'>
        <InfoAdd value='4' text='Years of work experience' />
        <InfoAdd value='20+' text='Completed projects' />
        <InfoAdd value='20+' text='Satisfied customers' />
      </div>
      <p className='descr'>
        At the moment, I'm studying in college to be a programmer.
        I am familiar with both front-end and back-end parts of website and app development.
      </p>
      <div className='btns'>
        <Btn link='#' class='btn btnDonate' value='Donate' />
        <Btn link='mailto:8cofiman@gmail.com' class='btn btnOther' value='Contact me' />
      </div>
    </>
  );
}

export default Info;
